<div class="card card-custom gutter-b example example-compact top-align">
  <div class="card-header">
      <h3 class="card-title">Candidate Feedback Form (Enrollment Stage)</h3>
      <div class="card-toolbar">
          <div class="example-tools justify-content-center">
              <button class="btn btn-secondary float-right" (click)='goBack()'>Back</button>
          </div>
      </div>
  </div>
  <div class="card-body" *ngIf="showLabel">
    <h2 >No Feedback Available</h2>
  </div>
  <div class="card-body" >
      <form class="form" [formGroup]="candidateFeedbackForm">
          <ng-container *ngIf="!hideForm">
            <div  formArrayName="feedbacks"
            *ngFor="let question of candidateFeedbackForm.get('feedbacks')['controls']; let i = index" class="form-group">
            <ng-container [formGroupName]="i">
  
              <div  formGroupName="feedback">
                  <label class="label-text" >{{questions[i].id}}) {{displayQuestion(questions[i].id,questions[i].questionString)}}</label>
                  <div class="radio-list" >
                      <label style="margin-left: 20px;" class="radio">
                          <input type="radio" (change)="check(i)" formControlName="choice"  [value]=true >
                          <span></span>
                          Yes
                      </label>
                      <label style="margin-left: 20px;"  class="radio">
                        <input type="radio" (change)="check(i)"  formControlName="choice"  [value]=false >
                        <span></span>
                        No
                    </label>
                  </div>
                </div>
            </ng-container>
            </div>
          </ng-container>
     
          <div class="card-footer">
            <ng-container *ngIf="role !== 'Training Partner'">
            <ng-container *ngIf="role !== 'Continuous Monitoring'">
                <ng-container *ngIf="feedbackType === 'non'">
                  <ng-container *ngIf="!isUpdate">
                    <button [disabled]="candidateFeedbackForm.status === 'INVALID'" *ngIf="role !== 'Training Partner'" class="btn btn-primary mr-2"  (click)="sumitFeedback()">Submit</button>
                    <!-- <button *ngIf="role !== 'Training Partner'" class="btn btn-primary mr-2"  (click)="reset()">Reset</button> -->
                  </ng-container>
                </ng-container>
            </ng-container>
         </ng-container>
          
          
          </div>
      </form>
</div>
</div>

   